export default __webpack_public_path__ + "static/agoric-system-logo-2457b9192d2bd5c18bfad52cae8432a4.svg";